/**
 * URL utilities for handling query parameters
 */

/**
 * Extracts a JWT token from URL query parameter 't'
 * @returns The JWT token if present, or null if not found
 */
export const extractJwtTokenFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('t');
};

/**
 * Checks if current host is in the list of known hosts
 * @param knownHosts List of known host domains
 * @returns True if the current host is in the known hosts list
 */
export const isKnownHostUrl = (knownHosts: string[]): boolean => {
  const currentHost = window.location.host;

  // return true
  
  return knownHosts.includes(currentHost);
};

/**
 * Removes the JWT token parameter from the URL without page reload
 */
export const removeTokenFromUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete('t');
  window.history.replaceState({}, document.title, url.toString());
}; 